// Temporary location until it lives in docs
export default {
  circles: 'https://platform.docs.lifeomic.com/user-guides/circles',
  files: 'https://platform.docs.lifeomic.com/user-guides/files/',
  insights: 'https://platform.docs.lifeomic.com/user-guides/insights/#overview',
  subjects: 'https://platform.docs.lifeomic.com/user-guides/subjects/',
  subjectViewerAddLayout:
    'https://platform.docs.lifeomic.com/user-guides/subject-viewer/#add-a-layout',
  cohorts: 'https://platform.docs.lifeomic.com/user-guides/cohorts/',
  automation: 'https://phc.docs.lifeomic.com/user-guides/automation/#overview', // page not found
  addData: 'https://platform.docs.lifeomic.com/user-guides/add-data/',
  knowledge: 'https://platform.docs.lifeomic.com/user-guides',
  mobileApp: 'https://platform.docs.lifeomic.com/user-guides/mobile-app',
  omicsExplorer: 'https://platform.docs.lifeomic.com/user-guides/omics/',
  omicsData:
    'https://platform.docs.lifeomic.com/user-guides/omics/data-processing/',
  ontologies: 'https://platform.docs.lifeomic.com/user-guides/ontologies',
  surveys: 'https://platform.docs.lifeomic.com/user-guides/surveys/#overview',
  consent: 'https://platform.docs.lifeomic.com/user-guides/consent/#overview',
  content: 'https://platform.docs.lifeomic.com/user-guides', // specific guide page needs to be made
  pml: 'https://platform.docs.lifeomic.com/user-guides/machine-learning',
  programs: 'https://platform.docs.lifeomic.com/user-guides/programs',
  accessControl:
    'https://platform.docs.lifeomic.com/user-guides/account-info/access-control/create-policy',
  fileActions: 'https://platform.docs.lifeomic.com/user-guides/files',
  sftp: 'https://platform.docs.lifeomic.com/user-guides/files/sftp/',
  tasks: 'https://devcenter.docs.lifeomic.com/development/tasks',
  trials: 'https://platform.docs.lifeomic.com/user-guides/clinical-trials',
};
